import React from 'react'
import {Legend, ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip} from 'recharts'
import roundUpCurrency from '../../utils/roundUpCurrency';
import reusableGraphConfig from './reusableGraphConfig';
import ReusableAxisTick from './ReusableAxisTick';
import generateGraphTicksFromPeriod from '../../utils/generateGraphTicksFromPeriod';

class ReusableGraph extends React.Component {
  state = {
    selection: {},
  }
  
  componentDidMount() {
    const { dataKeys } = this.props.graphProps;
    const selectionState = dataKeys.reduce(function(acc, dataKey) {
      acc[dataKey.dataKey] = 0
      return acc
      }, {selectedYear: 0});
    this.setState({
      selection: selectionState,
    });
  }
  
  handleLeave = (e) => {
    const { dataKeys } = this.props.graphProps;
    const selection = dataKeys.reduce(function(acc, dataKey) {
      acc[dataKey.dataKey] = 0
        return acc
      }, {selectedYear: 0});
    this.setState({selection: selection});
  }
  
  handleMove = (e) => {
    const { dataKeys } = this.props.graphProps;
    if (e.activePayload != null ) {
      const selection = dataKeys.reduce(function(acc, dataKey) {
        acc[dataKey.dataKey] = e.activePayload[0].payload[dataKey.dataKey] ? e.activePayload[0].payload[dataKey.dataKey] : 0
        return acc
      }, {selectedYear: e.activeLabel});
      this.setState({selection: selection});
    }
  }

  render() {
    const { selection } = this.state;
    const {
      graphData,
      loanTerm,
      graphLegendTitle,
      dataKeys,
      periodsKey,
      graphLegendYearIndication,
    } = this.props.graphProps;
    const { isDreamSpace } = this.props
    if (isDreamSpace) {
      reusableGraphConfig.colors = ['#683DE3', '#EDEBF9', '#FEF0DE'];
      reusableGraphConfig.colorsAsClasses = ['bg-dreamspace-purple', 'bg-dreamspace-mid-purple', 'bg-corn'];
    }

    return (
      <div>
        <div className='reusable-graph__graph-legend bg-grey border-top-0 text-center'>
          <h4 className='reusable-graph__graph-legend-title'>{graphLegendTitle}</h4>
          {graphLegendYearIndication && (<p>After {selection.selectedYear} years:</p>)}
          <div className='d-table m-auto'>
            {
              dataKeys.map((badge, index) => (
                <div className='d-table-cell pl-2 pr-2 pl-sm-3 pr-sm-3 smaller' key={index}>
                  <div>{badge.title}</div>
                    <div className={`badge white ${reusableGraphConfig.colorsAsClasses[index%3]}`}>
                      ${roundUpCurrency(selection[badge.dataKey])}
                    </div>
                </div>
              ))
            }
          </div>
        </div>
        <div className='list-group-item reusable-graph__graph-container position-relative'
            style={styles.chartContainer}>
          <div className="line-chart-wrapper">
            <ResponsiveContainer>
              <LineChart
                margin={styles.lineChartMargin}
                onMouseMove = { (e) => this.handleMove(e) }
                onMouseLeave = { (e) => this.handleLeave(e) }
                data={graphData}
              >
                <CartesianGrid
                  strokeDasharray='2, 0'
                  vertical={false}
                />
                <Tooltip wrapperStyle={{display: 'none'}} />
                  <Legend
                    content={() => {return (<span>Years</span>)}}
                    iconSize={0}
                    wrapperStyle={{textAlign: 'center', marginLeft: '30px'}}
                  />
                <XAxis
                  ticks={generateGraphTicksFromPeriod(loanTerm)}
                  dataKey={periodsKey}
                  {...reusableGraphConfig.xAxisProps}
                />
                <YAxis
                  tick={<ReusableAxisTick type='currency'/>}
                  {...reusableGraphConfig.yAxisProps}
                />
                {
                  dataKeys.map((dataKey, index) => (
                    <Line
                      key={index}
                      dataKey={dataKey.dataKey}
                      stroke={reusableGraphConfig.colors[index % 3]}
                      {...reusableGraphConfig.lineProps}
                    />
                  ))
                }
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  chartContainer: {
    width: '100%',
    height: '400px'
  },
  lineChartMargin: {
    top: 20,
    right: 30,
    left: 20,
    bottom: 20
  }
};

export default ReusableGraph;
